import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="delegate-template-row">
      <div className="delegate-template-col-no">{displayNo}</div>

      <div className="delegate-template-col-title">
        <Link
          to={`/documents/delegate/${item.id}`}
          className="delegate-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="delegate-template-col-writer">{item.writer}</div>
      <div className="delegate-template-col-date">{item.date}</div>
      <div className="delegate-template-col-view">{item.view}</div>
    </div>
  );
}